<template>
  <div class="reelbuzz">
    <div class="header">
        <div class="header-menu">
            <div class="header-left">
                <img src="../assets/logo.png" alt="logo-icon">
                <p>Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R..</p>
            </div>
            <ul class="header-right">
              <li v-for="section in sections" :key="section.id" class="menu">
                <a :href="'#' + section.id" @click="gotoMEnu(section.id)" :class="{ 'active': section.id === currentSection }">{{ section.title }}</a>
              </li>
            </ul>
        </div>
    </div>
    <div class="reelbuzz-content">
      <div class="reelbuzz-box" id="section1">
        <div class="header-box">
          <p class="name">Términos y Condiciones</p>
        </div>
      </div>
    </div>

    <div class="policy-box">

      <h1 class="policy-title">Términos y Condiciones</h1>

      <p class="policy-intro">
        Al utilizar los servicios de esta empresa, usted acepta los siguientes términos:
      </p>

      <h2 class="policy-section-title">1. Servicios</h2>
      <p>Ofrecemos soluciones financieras diversificadas dirigidas a personas y empresas, adaptadas a distintas necesidades.</p>

      <h2 class="policy-section-title">2. Uso de los Servicios</h2>
      <p>El usuario se compromete a hacer un uso adecuado, legal y responsable de los servicios ofrecidos.</p>

      <h2 class="policy-section-title">3. Condiciones Financieras</h2>
      <p>Los productos y servicios están sujetos a evaluación, aprobación y condiciones específicas según cada caso.</p>

      <h2 class="policy-section-title">4. Limitación de Responsabilidad</h2>
      <p>La empresa no se responsabiliza por decisiones financieras tomadas por el usuario ni por factores externos fuera de su control.</p>

      <h2 class="policy-section-title">5. Privacidad</h2>
      <p>La información del usuario será tratada de forma confidencial conforme a la normativa aplicable.</p>

      <h2 class="policy-section-title">6. Cambios en los Términos</h2>
      <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuo de los servicios implica la aceptación de estos términos y sus actualizaciones.</p>

    </div>

    <div class="footbox">
      <div class="footboxcard">
        <div class="footboxcarditem">
          <img src="../assets/address.png" alt="">
          Dirección: Lago Zurich 219, Piso 12, Colonia Ampliación Granada, <br> Miguel Hidalgo, Ciudad de México, C.P. 11529
        </div>
        <div class="footboxcarditem">
          <img src="../assets/email.png" alt="">
          Correo electrónico: support@creditosinfronteras.com
        </div>
      </div>
      <div class="footcopy">
        © Crédito Sin Fronteras, S.A.P.I. de C.V., SOFOM, E.N.R.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Terms",
  data() {
    return {
      sections: [
        { id: 'home', title: 'Inicio' },
        { id: 'policy', title: 'Política de privacidad' },
        { id: 'terms', title: 'Términos y Condiciones' },
      ],
      currentSection: 'terms'
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    gotoMEnu(id) {
      if (id === 'policy') {
        this.$router.push({ name: 'policy' })
        return
      }
      if (id === 'home') {
        this.$router.push({ name: 'Home' })
        return
      }
      if (id === 'terms') {
        this.$router.push({ name: 'terms' })
        return
      }
    },
  },
};
</script>

<style lang="less" scoped>
.policy-box {
  width: 80%;
  margin-left: 10%;
  border-radius: 20px;
  padding: 60px 60px 80px;
  box-sizing: border-box;
  background: #fff;
  font-size: 18px;
  color: #333;
  line-height: 1.8;
  margin-top: -100px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  .policy-title {
    font-size: 36px;
    font-weight: bold;
    color: #101010;
    margin-bottom: 28px;
    padding-bottom: 16px;
    border-bottom: 3px solid #DDF247;
  }

  .policy-intro {
    color: #555;
    margin-bottom: 16px;
  }

  .policy-section-title {
    font-size: 22px;
    font-weight: bold;
    color: #101010;
    margin-top: 40px;
    margin-bottom: 16px;
    padding-left: 14px;
    border-left: 4px solid #DDF247;
  }

  p {
    margin-bottom: 12px;
  }
}
.policy-box:hover {
  transform: translateY(-20px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}
.color-fff { color: #fff; }
.color-000 { color: #000; }
.header {
  position: fixed;
  width: 100%;
  z-index: 999;
  transition: 0.5s;
  height: 100px;
  background: #101010;
  color: #fff;

  .header-menu {
    width: 100%;
    max-width: 1800px;
    height: 100px;
    margin: 0 auto;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-left {
      height: 100px;
      flex: 0 1 auto;
      display: flex;
      align-items: center;
      margin-right: 24px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }

      p {
        font-family: Scada, Scada;
        font-weight: bold;
        font-size: 22px;
        color: #fff;
        line-height: 38px;
      }
    }

    .header-right {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      list-style: none;
      margin: 0;
      padding: 0;
      flex: 1;
      background: #101010;
      box-sizing: border-box;
      color: #fff;

      .menu {
        margin: 0 10px;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;

        a {
          color: #fff;
          padding: 8px 10px;
        }

        .active {
          color: #000;
          cursor: pointer;
        }
      }

      .menu:last-child {
        margin-right: 0;
      }

      .active {
        font-weight: 900;
        color: #000;
        border-radius: 20px;
        background: #DDF247;
        transition: all 0.8s;
      }
      .active a {
        color: #000;
      }
    }
  }
}
.reelbuzz-content {
  padding-top: 95px;

  .reelbuzz-box {
    width: 100%;
    height: 800px;
    background: url(../assets/bannel.png) center top no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .header-box {
      width: 1220px;
      height: 100%;
      margin: 0 auto;
      padding-top: 195px;
      box-sizing: border-box;
      padding-right: 500px;

      .name {
        font-weight: bold;
        font-size: 50px;
        color: #fff;
        line-height: 70px;
        margin-bottom: 32px;
      }
    }
  }
}
.footbox {
  margin-top: 60px;
  padding: 40px 15%;
  background: #101010;
  box-sizing: border-box;

  .footboxcard {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .footboxcarditem {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 16px;
      line-height: 1.6;

      img {
        width: 30px;
        height: 30px;
        margin-right: 14px;
      }
    }
  }

  .footcopy {
    text-align: center;
    color: #888;
    font-size: 14px;
    border-top: 1px solid #333;
    padding-top: 20px;
  }
}
</style>
